import React from 'react';
import { motion } from 'framer-motion';
export function BookDescription() {
  return <section className="py-16 md:py-24 bg-matrix-black relative px-4" data-id="element-24">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex-1" data-id="element-26">
          
          <div className="relative" data-id="element-27">
            <div className="absolute inset-0 bg-matrix-green blur-[80px] opacity-20" data-id="element-28"></div>
            <img src="https://cdn.magicpatterns.com/uploads/xebK7TBko2oQe2uyP6uAQA/Ebook_EStas_listo_para_jugar_.png" alt="Libro: ¿Estás listo para jugar?" className="relative z-10 w-64 md:w-full max-w-md mx-auto rounded-lg shadow-2xl border border-matrix-green/20" data-id="element-29" />
            
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex-1" data-id="element-30">
          
          <h2 className="font-cinzel text-3xl md:text-4xl text-matrix-cream mb-6" data-id="element-31">
            Un viaje sin retorno hacia la verdad
          </h2>
          <div className="space-y-4 md:space-y-6 text-matrix-white text-base md:text-lg font-light" data-id="element-32">
            <p data-id="element-33">
              Este no es un libro de autoayuda convencional. Es un manual de
              desprogramación.
            </p>
            <p data-id="element-34">
              A través de sus páginas, serás guiado paso a paso para identificar
              las líneas de tu "código fuente" que gobiernan tu mente,
              aprendiendo a reescribirlas. Será un viaje intenso, revelador y
              profundamente transformador.
            </p>
            <p className="font-medium text-matrix-cream" data-id="element-35">
              Una vez que tejas tus propios hilos, ya no volverás a ser
              marioneta.
            </p>
          </div>

          <div className="mt-8 md:mt-10 grid grid-cols-2 gap-4 md:gap-6" data-id="element-36">
            <div className="border-l-2 border-matrix-green pl-4" data-id="element-37">
              <div className="text-2xl md:text-3xl font-cinzel text-matrix-green mb-1" data-id="element-38">
                100%
              </div>
              <div className="text-xs md:text-sm text-matrix-white/70" data-id="element-39">
                Transformación digital
              </div>
            </div>
            <div className="border-l-2 border-matrix-green pl-4" data-id="element-40">
              <div className="text-2xl md:text-3xl font-cinzel text-matrix-green mb-1" data-id="element-41">
                Inmediato
              </div>
              <div className="text-xs md:text-sm text-matrix-white/70" data-id="element-42">
                Acceso al descargar
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}